import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const getAssessments = () =>
    axios
        .get(
            "/wp-json/wp/v2/services?_fields[]=title&_fields[]=id&per_page=100"
        )
        .then((res) => res?.data);

export default function useAssessments() {
    return useQuery(["assessments"], getAssessments, {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    });
}
